class AdvancedSearchPanel {
    constructor(element) {
        if(!element) return;
        this.element = element;
        this.header = this.element.querySelector(".accordion__header");
        this.content = this.element.querySelector(".accordion__content");
        this.filtersList = this.element.querySelectorAll('.advanced-search__filter');
        this.filters = {};
        this.init();
    }


    toggleAccordion() {
        this.element.classList.toggle("accordion--open");
        this.content.classList.toggle("accordion__content--open");
    }

    clearAllSelections() {
        this.filtersList.forEach((filterElement) => {
            const inputs = filterElement.querySelectorAll("input[type='radio']");
            inputs.forEach((input) => input.checked = false);
            const selectionText = filterElement.querySelector(".selection");
            if (selectionText) selectionText.textContent = "Nessuna selezione";
        });
    }


    addSelectsListener() {
        this.filtersList.forEach((el) => {
            const inputs = el.querySelectorAll("input[type='radio']");
            inputs.forEach((input) => {
                input.addEventListener("change", (event) => this.updateSelection(event, el));
            });

            el.querySelector('.filter-option').addEventListener('click', () => {
                const dropdownContent = el.querySelector('.dropdown-content');
                const filterOption = el.querySelector(".filter-option");

                const openedDropdown = this.element.querySelector('.dropdown-content.show');
                if(openedDropdown && openedDropdown !== dropdownContent) {
                    const openedOption = this.element.querySelector('.filter-option.open');
                    openedDropdown.classList.remove('show');
                    openedOption.classList.remove("open");
                }
                dropdownContent.classList.toggle("show");
                filterOption.classList.toggle("open");


                const isOpen = dropdownContent.classList.contains("show");
                const dropdownIcon = el.querySelector(".dropdown-icon");
                dropdownIcon.classList.toggle("rotated");
                if (isOpen) {
                    dropdownIcon.classList.add("danger");
                    dropdownIcon.classList.remove("dark");
                } else {
                    dropdownIcon.classList.add("dark");
                    dropdownIcon.classList.remove("danger");
                }
            })
        });
    }


    updateSelection(event, el) {
        const value = event.target.labels[0]?.textContent;
        el.querySelector('.selection').textContent = value || "Nessuna selezione";
    }


    getActiveFilters() {
        const filters = {};
        filters.diff = this.element.querySelector('input[name="difficulty"]:checked')?.value;
        filters.course = this.element.querySelector('input[name="course"]:checked')?.value;
        filters.time = this.element.querySelector('input[name="time"]:checked')?.value;
        filters.ing = this.element.querySelector('input[name="ingredients"]')?.value;
        return filters;
    }

    setInputValue(value) {
        if(!value) return;
        const element = this.element.querySelector(`input[value="${value}"]`);
        if(!element) return;
        element.checked = true;
        const label = element.parentElement.textContent;
        element.closest('.advanced-search__filter').querySelector('.selection').textContent = label || "Nessuna selezione";
    }

    setActiveFilters(filters) {
        this.setInputValue(filters.diff);
        this.setInputValue(filters.course);
        this.setInputValue(filters.time);
        this.element.querySelector('input[name="ingredients"]').value = filters.ing;
    }


    init() {
        this.header.addEventListener("click", () => this.toggleAccordion());
        this.clearSelectionBtn = this.element.querySelector(".clear-selection");
        this.clearSelectionBtn?.addEventListener("click", () => this.clearAllSelections());
        this.addSelectsListener();
    }
}

export default AdvancedSearchPanel;
